import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MedicationService {
    constructor(
        private httpClient: HttpClient,
        private toastr: ToastrService
    ) {}
    private apiUrl = environment.apiUrl;
    addMedication(medication: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Medication/AddMedication`, medication)
            .pipe
            //catchError(this.error)
            ();
    }

    GetMedicationDataNumbers(farmId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Medication/GetMedicationDataNumbers?farmId=${farmId}`
            )
            .pipe();
    }

    getMedicationList(
        userId: number,
        page: any,
        pageSize: any,
        filters?: any
    ): Observable<any> {
        const params = {userId, page, pageSize};
        return this.httpClient.post(
            `${this.apiUrl}/Medication/GetMedicationList`,
            filters || {},
            {params}
        );
    }
    getMedicationListByUserId(userId: number) {
        return this.httpClient
            .get(
                `${this.apiUrl}/Medication/GetMedicationListByUserId?userId=${userId}`
            )
            .pipe
            //catchError(this.error)
            ();
    }
    getChicksTypeList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/ChicksTypeList`)
            .pipe
            //catchError(this.error)
            ();
    }
    getApplicationTypeList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Medication/ApplicationTypeList`)
            .pipe
            //catchError(this.error)
            ();
    }
    getSuppierList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Supplier/GetSupplierList`)
            .pipe
            // catchError(this.error)
            ();
    }
    getClassificationList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Medication/ClassificationTypeList`)
            .pipe
            // catchError(this.error)
            ();
    }

    getMedicationById(id: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Medication/GetMedicationDetailsById?id=${id}`)
            .pipe
            //catchError(this.error)
            ();
    }
    updateMedicationDetail(medicationModel: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Medication/UpdateMedicationDetail`,
                medicationModel
            )
            .pipe
            //catchError(this.error)
            ();
    }

    getMedicationDetailInfoById(id: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Medication/MedicationDetailInfoById?id=${id}`)
            .pipe
            //catchError(this.error)
            ();
    }

    deleteMedication(medicationId: number): Observable<any> {
        return this.httpClient
            .delete(
                `${this.apiUrl}/Medication/DeleteMedication?id=${medicationId}`
            )
            .pipe
            //catchError(this.error)
            ();
    }
}
